import React, { useCallback } from 'react';
import { IntlProvider, useIntl } from 'react-intl-next';
import { useFetchMessagesByLocale } from './useFetchMessagesByLocale';
import { useAnalytics } from '../../analytics';
import { IntlProviderAnalytics } from './IntlProviderAnalytics';

interface IntlProviderType {
	children: React.ReactElement<any>;
}

const InvitePeopleIntlProvider = ({ children }: IntlProviderType): React.JSX.Element => {
	const analytics = useAnalytics(IntlProviderAnalytics);
	const { locale } = useIntl();
	const { messages } = useFetchMessagesByLocale(locale);

	const onErrorHandler = useCallback(
		(error: Error) => {
			analytics.translationMessageError({
				error: {
					locale: locale,
					errorMessage: error.message.trim(),
				},
			});
		},
		[analytics, locale],
	);

	return (
		<IntlProvider messages={messages} key={locale} locale={locale} onError={onErrorHandler}>
			{children}
		</IntlProvider>
	);
};

export default InvitePeopleIntlProvider;
